
export const getUrl = () => {
    let url: string =
        import.meta.env.PROD ?
            import.meta.env.VITE_WEBSITE_URL :
            'http://localhost:5173/'
    url = url.startsWith('http') ? url : `https://${url}`
    url = url.endsWith('/') ? url : `${url}/`
    // return url
    return `${location.origin}/`
}